import { cn } from "../../../lib/utils";
import { Suggestion } from "../../../types/document";
import { resolveSentimentMarkerColor } from "./blockUtils";

interface BlockMarkersProps {
  isSelected: boolean;
  suggestion?: Suggestion;
  isListItem?: boolean;
}

export const BlockMarkers = ({
  isSelected,
  suggestion,
  isListItem = false,
}: BlockMarkersProps) => {
  const suggestionSentiment = suggestion?.sentiment;
  const suggestionStatus = suggestion?.status;
  const isRejected = suggestionStatus === "rejected";

  if (!isSelected) {
    return null;
  }

  const markerColor = suggestion
    ? resolveSentimentMarkerColor(
        suggestion.sentiment,
        suggestion.classification ?? undefined
      )
    : null;
  const leftClass = isListItem ? "left-[-44px]" : "left-[-22px]";
  const verticalClass = isListItem ? "top-2 bottom-2" : "top-0 bottom-0";

  return (
    <div
      className={cn(
        "absolute flex flex-col items-center gap-2",
        leftClass,
        verticalClass
      )}
    >
      {suggestion &&
        suggestionStatus === "pending" &&
        suggestionSentiment !== "neutral" &&
        !isRejected && (
          <div className={cn("w-1 h-10 rounded-sm", markerColor)} />
        )}
      <div className="w-1 h-full rounded-sm bg-blue-500" />

      {/* Just to force inclusion of dynamic variables */}
      <span className="bg-purple-50 hidden"></span>
      <span className="bg-purple-500 hidden"></span>
      <span className="border-purple-500 hidden"></span>
    </div>
  );
};
